import { SearchDefaultFilter, SearchField } from '../models/serviceModels/SearchConfig';

export const PARTICIPANT_SEARCH_FIELDS: SearchField[] = [
    { fieldId: 'firstName',        label: 'First Name',    type: 'text' },
    { fieldId: 'lastName',         label: 'Last Name',     type: 'text' },
    { fieldId: 'dateOfBirthRange', label: 'Date of Birth', type: 'dateRange' },
    { fieldId: 'phoneNumber',      label: 'Phone Number',  type: 'phone' },
    { fieldId: 'email',            label: 'Email',         type: 'text' },
    { fieldId: 'programName',      label: 'Program',       type: 'program' },
];

export const PARTICIPANT_DEFAULT_FILTERS: SearchDefaultFilter[] = [
    { flagKey: 'excludeInactive', label: 'Exclude Inactive', disableText: 'Include Inactive' },
    { flagKey: 'assignedToMe',    label: 'Assigned to Me',   disableText: 'Assigned to Me' },
];
